import CityPageTemplate from "../city-template/CityPageTemplate";
import { ashlandConfig } from "./data";

export default function AshlandPage() {
  return <CityPageTemplate config={ashlandConfig} />;
}